module.exports = __webpack_public_path__ + "img/down_piano_rubbish.0b482f03.png";